import { seamlessApi } from "../../../helpers";
export function scrollToTop() {
    seamlessApi.operator.scrollToTop();
}
//# sourceMappingURL=EventHandlers.js.map